import React, { useState, useEffect, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { stepArr, stepUrl } from '../variables/generalVariables';
import HistoryMenu from '../HistoryMenu/HistoryMenu';
import { emptySession } from '../variables/sessionVariables';
import './Header.scss';
//import i18n from '../Locales/i18n';

const UrlButton = (props) => {
    const { onClick, url, classes, isDisabled } = props;

    return (
        <button
            className={`url-step ${classes || ''}`}
            onClick={() => onClick(url)}
            disabled={isDisabled}
        >
            {props.children}
        </button>
    );
};

const Header = (props) => {
    const {
        history,
        goToPage,
        scoreBoard,
        startCaseInfo,
        vitalia,
        version,
        t
    } = props;
    const [scoreBoardKeys, setScoreBoardKeys] = useState([]);
    const [sidemenuOpen, setSideMenuOpen] = useState(false);
    const [nihhsMenuOpen, setNihhsMenuOpen] = useState(false);
    const [isDisabled, setIsDisabled] = useState({
        symptomdebut: true,
        legemidler: true,
        vitalia: true,
        summary: true
    });
    const location = useLocation();
    const stepArray = stepArr(t);
    // const changeLanguage = (lng) => {
    //     i18n.changeLanguage(lng);
    // };

    useEffect(() => {
        const arr = Object.keys(scoreBoard).map((key) => key);
        setScoreBoardKeys(arr);
        let changeAny = false;

        let disabledMap = { ...isDisabled };
        if (arr.length >= stepArray.length) {
            if (disabledMap['vitalia']) {
                disabledMap['vitalia'] = false;
                changeAny = true;
            }
            if (disabledMap['summary']) {
                disabledMap['summary'] = false;
                changeAny = true;
            }
        }

        if (changeAny) setIsDisabled(disabledMap);
    }, [scoreBoard, isDisabled, stepArray.length]);

    useEffect(() => {
        let changeAny = false;
        let disabledMap = { ...isDisabled };

        if (vitalia && vitalia.sbValidated && disabledMap['legemidler']) {
            disabledMap['legemidler'] = false;
            changeAny = true;
        }

        if (changeAny) setIsDisabled(disabledMap);
    }, [vitalia, isDisabled]);

    useEffect(() => {
        let disabledMap = { ...isDisabled };
        let changeAny = false;

        if (
            startCaseInfo &&
            startCaseInfo.validOk &&
            disabledMap['symptomdebut']
        ) {
            disabledMap['symptomdebut'] = false;
            changeAny = true;
        }

        if (changeAny) setIsDisabled(disabledMap);
    }, [startCaseInfo, isDisabled]);

    const clickGoBack = (e) => {
        emptySession();
        goToPage('/');
        setSideMenuOpen(false);
    };
    const goTo = (e) => {
        goToPage(e);
        if (sidemenuOpen) setSideMenuOpen(false);
    };
    const goBackOne = () => {
        let aIn = ['/nypasient'];

        if (version === 'web') {
            aIn.push('/identifiser');
        }

        aIn.push('/symptomdebut', '/medikamenter', '/pasient');

        stepArray.forEach((step) => {
            aIn.push(stepUrl(step));
        });
        aIn = [...aIn, '/vitalia', '/oppsummering'];
        const indx = aIn.indexOf(location.pathname);

        if (indx < 1) goToPage('/');
        else {
            let n = aIn[indx - 1];
            goToPage(n);
        }
    };
    const nihssDisabled = (urlStr) => {
        const str = urlStr.replace('/', '');
        if (scoreBoard[str]) {
            return false;
        }
        return true;
    };

    return (
        <header className='Header'>
            {history.location.pathname.length > 1 &&
                history.location.pathname !== '/overview' && (
                    <Fragment>
                        <button onClick={goBackOne} className='btn-backstep'>
                            {t('web.general.btns.previous')}
                        </button>
                        <HistoryMenu
                            goToPage={goToPage}
                            version={version}
                            t={t}
                        />
                        <button
                            aria-label='åpne meny'
                            className='hamburgermenu is-closed'
                            onClick={() => setSideMenuOpen(!sidemenuOpen)}
                        >
                            {t('web.general.btns.menu')}
                            <span className='menu-icn'></span>
                        </button>
                        <nav
                            className={`header-nav ${
                                sidemenuOpen ? 'is-open' : 'is-closed'
                            }`}
                        >
                            <button
                                aria-label='Lukk menu'
                                className='hamburgermenu is-open'
                                onClick={() => setSideMenuOpen(!sidemenuOpen)}
                            >
                                {t('button.close')}
                                <span className='menu-icn'></span>
                            </button>
                            <button
                                className='btn-end-session'
                                onClick={clickGoBack}
                            >
                                {t('web.general.btns.cancel_survey')}
                            </button>
                            {version === 'web' && (
                                <UrlButton
                                    onClick={goTo}
                                    url={'/identifiser'}
                                    isCurrent={
                                        location.pathname === '/identifiser'
                                    }
                                >
                                    {t('web.identification.person_id')}
                                </UrlButton>
                            )}
                            <UrlButton
                                onClick={goTo}
                                url={'/symptomdebut'}
                                isCurrent={
                                    location.pathname === '/symptomdebut'
                                }
                                isDisabled={isDisabled.symptomdebut}
                            >
                                {t('form.symptoms.title')}
                            </UrlButton>
                            <UrlButton
                                onClick={goTo}
                                url={'/medikamenter'}
                                isCurrent={
                                    location.pathname === '/medikamenter'
                                }
                                isDisabled={isDisabled.legemidler}
                            >
                                {t('form.medication.title')}
                            </UrlButton>
                            <UrlButton
                                onClick={goTo}
                                url={'/pasient'}
                                isCurrent={location.pathname === '/pasient'}
                            >
                                {t('general.patient')}
                            </UrlButton>
                            <button
                                className={`nihss-showhide ${
                                    nihhsMenuOpen ? 'is-open' : 'is-closed'
                                }${
                                    scoreBoardKeys.length === 0
                                        ? ' all-disabled'
                                        : ''
                                }`}
                                onClick={() => setNihhsMenuOpen(!nihhsMenuOpen)}
                            >
                                NIHSS
                            </button>
                            <div
                                className={`nihhs-areaurls ${
                                    nihhsMenuOpen ? 'show-area' : 'hide-area'
                                }`}
                            >
                                {stepArray.map((step, i) => {
                                    const encUrl = stepUrl(step);
                                    return (
                                        <UrlButton
                                            key={`${step}--${i}`}
                                            onClick={goTo}
                                            url={encUrl}
                                            isCurrent={
                                                location.pathname === encUrl
                                            }
                                            classes='is-nihss'
                                            isDisabled={nihssDisabled(encUrl)}
                                        >
                                            <span className='nihss-ref'>
                                                {step.NIHSSref}
                                            </span>{' '}
                                            {step.title}
                                        </UrlButton>
                                    );
                                })}
                            </div>
                            <UrlButton
                                onClick={goTo}
                                url={'/vitalia'}
                                isCurrent={location.pathname === '/vitalia'}
                                isDisabled={isDisabled.vitalia}
                                classes='no-margin-top'
                            >
                                {t('form.vitals.title')}
                            </UrlButton>
                            <UrlButton
                                onClick={goTo}
                                url={'/oppsummering'}
                                isCurrent={
                                    location.pathname === '/oppsummering'
                                }
                                isDisabled={isDisabled.summary}
                            >
                                {t('web.summary.title')}
                            </UrlButton>
                        </nav>
                    </Fragment>
                )}
        </header>
    );
};

export default Header;
